import { render, staticRenderFns } from "./UserOffices.vue?vue&type=template&id=a8d72594&scoped=true&"
import script from "./UserOffices.vue?vue&type=script&lang=js&"
export * from "./UserOffices.vue?vue&type=script&lang=js&"
import style0 from "./UserOffices.vue?vue&type=style&index=0&id=a8d72594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d72594",
  null
  
)

export default component.exports